// ============================================================================
// Client Auth Helper — get JWT token dari sessionStorage untuk Authorization
// ============================================================================
// Token disimpan oleh SecurityGate setelah login sukses (level='admin').
// Format header: `Authorization: Bearer <jwt>` per HTTP standard.
// ============================================================================

const SESSION_KEY = 'horus.access.admin.token';

/**
 * Get JWT token dari sessionStorage. Return null kalau belum login.
 */
export function getAuthToken() {
  try {
    return sessionStorage.getItem(SESSION_KEY) || null;
  } catch {
    return null;
  }
}

/**
 * Build headers object dengan Authorization Bearer kalau ada token.
 * Pakai untuk fetch() ke API endpoint protected (apify-*, face-compare).
 *
 * Usage:
 *   fetch('/api/apify-discover', {
 *     headers: { 'Content-Type': 'application/json', ...getAuthHeaders() },
 *     ...
 *   });
 */
export function getAuthHeaders() {
  const token = getAuthToken();
  return token ? { Authorization: `Bearer ${token}` } : {};
}
